// extracted by mini-css-extract-plugin
export default {"signupContainer":"SignupPage_signupContainer__oMxwc","signupForm":"SignupPage_signupForm__ZF3lE","successMsg":"SignupPage_successMsg__vbd08","errorMsg":"SignupPage_errorMsg__1vIh9"};